export enum APP_ENV {
  DEV = 'DEV',
  PROD = 'PROD',
}

export enum Coin {
  BSC = 'bsc',
  LIX = 'lix',
  USDT = 'usdt',
  USDC = 'usdc',
}

export enum CoinSymbol {
  BSC = 'BSC',
  LIX = 'LIX',
  USDT = 'USDT',
  USDC = 'USDC',
}

export enum RewardType {
  NFT_NODE = 'NFT_NODE',
  ERC_20 = 'ERC_20',
}

export enum METHOD_PAYMENT {
  CRYPTO = 'CRYPTO',
  CARD = 'CARD',
}
